import { withStyles } from "@material-ui/core";
import {
  getCloneConfirmationText,
  getCloneTargetType,
  getNonClonableZoneNames,
} from "../utils";

const styles = (theme) => ({
  text: {
    color: theme.TextColor,
  },
  info: {
    wordBreak: "break-all",
  },
  bold: {
    fontWeight: 600,
  },
});
const CloneConfirmationContent = ({
  currentType,
  nonClonableZoneIds,
  routeMappingData,
  classes,
}) => {
  const nonClonableZoneNames = getNonClonableZoneNames(
    routeMappingData,
    nonClonableZoneIds
  );

  return (
    <div className={classes.text}>
      <span>{getCloneConfirmationText(currentType)}</span>
      {nonClonableZoneIds.length > 0 && (
        <p className={classes.info}>
          <span className={classes.bold}>Note:</span> {currentType} zones {nonClonableZoneNames.join(",")} will be
          excluded as the {getCloneTargetType(currentType)} zone with the same
          names already exist.
        </p>
      )}
    </div>
  );
};

export default withStyles(styles)(CloneConfirmationContent);
